// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AffairsTab_wrapper__10BsM","wrapper__button":"AffairsTab_wrapper__button__d5lGM"};